import { registerPlugin } from '@capacitor/core';

export type InAppCheckoutResult = {
  status: 'return' | 'cancel';
  url: string;
};

export interface InAppCheckoutPlugin {
  open(options: { url: string }): Promise<InAppCheckoutResult>;
}

const InAppCheckout = registerPlugin<InAppCheckoutPlugin>('InAppCheckout');

export default InAppCheckout;
